module.exports = __webpack_public_path__ + "media/images/icon__predict-0574e629818e484ab84e69ecb78a01a4.png";